module.exports = __webpack_public_path__ + "img/icon-lightbulb-light.7dd761c3.svg";